/**
 * Product Tabs — vanilla JS tab switcher with ARIA support
 */
(function () {
  const tabLists = document.querySelectorAll('.product-tabs__nav');

  tabLists.forEach((tabList) => {
    const tabs = tabList.querySelectorAll('.product-tabs__tab');
    const panels = tabList.parentElement.querySelectorAll('.product-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.remove('product-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });

        panels.forEach((p) => {
          p.classList.remove('product-tabs__panel--active');
          p.setAttribute('hidden', '');
        });

        tab.classList.add('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');

        const panelId = tab.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (panel) {
          panel.classList.add('product-tabs__panel--active');
          panel.removeAttribute('hidden');
        }
      });

      tab.addEventListener('keydown', (e) => {
        const tabArray = Array.from(tabs);
        const index = tabArray.indexOf(tab);
        let newIndex;

        if (e.key === 'ArrowRight') {
          newIndex = (index + 1) % tabArray.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (index - 1 + tabArray.length) % tabArray.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabArray.length - 1;
        }

        if (newIndex !== undefined) {
          e.preventDefault();
          tabArray[newIndex].click();
          tabArray[newIndex].focus();
        }
      });
    });
  });
  // TMS: "What size am I?" link clicks the Size Chart tab and scrolls to it. Delegated,
  // because the link sits inside variant-selects, which is re-rendered on every option change.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-size-chart-link]');
    if (!link) return;
    e.preventDefault();
    const sizeTab = document.querySelector('[id^="tab-size-chart-"]');
    if (sizeTab) {
      sizeTab.click();
      sizeTab.closest('.product-tabs').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
